import { render, staticRenderFns } from "./AddSettlementPreference.vue?vue&type=template&id=6079d7fa&scoped=true"
import script from "./AddSettlementPreference.vue?vue&type=script&lang=js"
export * from "./AddSettlementPreference.vue?vue&type=script&lang=js"
import style0 from "./AddSettlementPreference.vue?vue&type=style&index=0&id=6079d7fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6079d7fa",
  null
  
)

export default component.exports